import { Table, Button, Modal } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useQuery } from 'react-query';
import { getSubscriptions } from '../../api/queries';
import { DrawerLayout } from '../../Layout';
import { columns } from './data';
import style from './styles';
import { paginationStyles } from '../common';
import { PlusOutlined } from '@ant-design/icons';
import AddSubscriptionForm from './components/AddSubscription';
import EditSubscriptionForm from './components/EditSubscription';

const SubscriptionsWrapper = styled.div`
    ${style}
    ${paginationStyles}
`;

const SubscriptionsComponent = () => {
    const [openModal, setOpenModal] = useState<string>('');
    const [editData, setEditData] = useState<any>(null);
    const { isFetching, data, refetch } = useQuery('subscriptions', getSubscriptions, {
        refetchOnWindowFocus: false,
    });

    const onEdit = (record) => {
        setEditData(record);
        setOpenModal('edit');
    };

    return (
        <DrawerLayout>
            <SubscriptionsWrapper>
                <div className={'header'}>
                    <div className="flex-1" />
                    <Button
                        className={'primary-button add-button'}
                        icon={<PlusOutlined />}
                        onClick={() => setOpenModal('add')}
                    >
                        Add Subscriptions
                    </Button>
                </div>
                <Table
                    loading={isFetching}
                    rowKey={'name'}
                    columns={columns(onEdit)}
                    dataSource={data?.subscriptions ?? []}
                    locale={{ emptyText: 'No Subscriptions' }}
                />
                <Modal
                    destroyOnClose
                    title={openModal === 'add' ? 'Add Subscription' : 'Edit Subscription'}
                    visible={openModal !== ''}
                    onCancel={() => setOpenModal('')}
                    footer={null}
                >
                    {openModal === 'add' ? (
                        <AddSubscriptionForm
                            closeModal={() => {
                                setOpenModal('');
                                refetch();
                            }}
                        />
                    ) : (
                        <EditSubscriptionForm
                            record={editData}
                            closeModal={() => {
                                setOpenModal('');
                                refetch();
                            }}
                        />
                    )}
                </Modal>
            </SubscriptionsWrapper>
        </DrawerLayout>
    );
};

export default SubscriptionsComponent;
